export const ROUTES = {
  CLIENT: {
    ROOT: '/:country/verification',
    PAGES: {
      ROOT: '/',
      INSTITUTION: {
        ROOT: '/institution',
        SUPPORT: '/support'
      },
      PORTAL: {
        ROOT: '/portal',
        ERROR: '/error'
      },
      EMAIL: {
        ROOT: '/email',
        SENT: '/sent',
        SUPPORT: '/support',
        INBOUND: '/inbound'
      },
      MANUAL: {
        ROOT: '/manual',
        UPLOAD: '/upload',
        SENT: '/sent'
      },
      METHODS: '/methods',
      EXPIRED: '/expired',
      GRADUATION: {
        ROOT: '/graduation',
        SUCCESS: '/success'
      },
      COUNTRY: {
        ROOT: '/country'
      },
      SUCCESS: {
        ROOT: '/success'
      }
    }
  },
  SERVER: {
    GRAPHQL: 'graphql_path',
    SUPPORT: 'sbid_support_path',
    PASSTHROUGH: 'verification_app_passthrough_path',
    PRIVACY: 'privacy_path'
  }
}

export const VERIFICATION_METHOD_PAGES = {
  email: ROUTES.CLIENT.PAGES.EMAIL.ROOT,
  manual: ROUTES.CLIENT.PAGES.MANUAL.ROOT,
  portal: ROUTES.CLIENT.PAGES.PORTAL.ROOT,
  email_inbound: ROUTES.CLIENT.PAGES.EMAIL.INBOUND
}
